import type { FC } from 'react';

import { CallDetailsParticipant } from 'features/call/call-details/components';
import {
  useCallDetailsCallee,
  useCallDetailsCaller,
} from 'features/call/call-details/hooks';
import { Separator } from 'features/call/call-details/styles';
import { CallDetailsAddVco2Line } from 'features/vco-2-line/components';

export const CallDetailsAddNumberVco2Line: FC = () => {
  const { caller } = useCallDetailsCaller();
  const { callee } = useCallDetailsCallee();

  return (
    <>
      <CallDetailsParticipant {...caller} />
      <CallDetailsAddVco2Line />
      <Separator />
      <CallDetailsParticipant {...callee} />
    </>
  );
};
